/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, Image, Dimensions, ScrollView, FlatList, RefreshControl } from 'react-native'
import { Images, Fonts, Colors } from '../Themes'
import styles from './Styles/ExploraPeopleStyle'
import FollowComponent from './FollowComponent'
import ImageComponent from './ImageComponent'
import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview"

let { width } = Dimensions.get('window')
const minHeight = 50
const viewabilityConfig = { viewAreaCoveragePercentThreshold : -200 }

const noPostsHeight = 60
const withPostsHeight = 163.7

const SEARCH_DELAY_MS = 333

export default class ExploraPeople extends Component {
// class ExploraPeople extends Component {
  constructor(props) {
    super(props)
    console.tron.display({name: 'ExploraPeople', preview: "constructor", value: {props: props}})
    // just pass in search term for rendering, that's all
    this.state = {
      render: Date.now(),
      refreshing: false,
    }
    this.scrollView = null
    this.data = []
    let dataProvider = new DataProvider((r1, r2) => { return r1.UserId+r1.Username+r1.UserIsFollowing != r2.UserId+r2.Username+r2.UserIsFollowing })
    this._dataProvider = dataProvider.cloneWithRows(this.data)
    this._layoutProvider = new LayoutProvider(
      index => this._dataProvider._data[index].Posts.length == 0 ? 'NO-POSTS' : 'POSTS',
      (type, dim) => {
        dim.width  = width
        dim.height = type == 'NO-POSTS' ? noPostsHeight : withPostsHeight
    })
    // this._inLoadMoreData = false
    this.userCache = []

    this._renderRow = this._renderRow.bind(this)
    this._loadMoreData = this._loadMoreData.bind(this)
    this._onRefresh = this._onRefresh.bind(this)
    this.componentDidMount = this.componentDidMount.bind(this)
    this.componentDidUpdate = this.componentDidUpdate.bind(this)
    this.addRowsFromCache = this.addRowsFromCache.bind(this)
    this.followUnfollow = this.followUnfollow.bind(this)
    this.performSearch = this.performSearch.bind(this)

    this.searchTimer = null
  }
  
  performSearch() {
    this.props.getUsers(this.props.search)
  }
  
  componentWillUnmount ( ) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = false
    }
  }
  
  componentDidMount() {
    this.props.getUsers(this.props.search)
  }
  
  componentDidUpdate(previousProps, previousState) {
    const postPeople = this.props.postPeople
    console.tron.display({name: 'ExploraPeople', preview: "componentDidUpdate", value: {props: this.props, previousProps: previousProps, postPeople: postPeople}})

    if (previousProps.follow.updateCounter != this.props.follow.updateCounter) {
      // maybe there was a visit to a profile page, and follow state was changed there
      const userId = this.props.follow.user2Id
      const changedRows = this._dataProvider._data.slice(0)
      for (let i = 0; i < changedRows.length; i++)
        if (changedRows[i].UserId == userId)
          if (this.props.follow.following != changedRows[i].UserIsFollowing) {
            console.tron.display({name: 'ExploraPeople', preview: "componentDidUpdate follow state change detected", value: {followState: this.props.follow}})
            changedRows[i] = Object.assign({}, changedRows[i], {UserIsFollowing: this.props.follow.following})
            this._dataProvider = this._dataProvider.cloneWithRows(changedRows)
            this.setState({render: Date.now()})
            i = changedRows.length
          }
    }

    if (previousProps.search != this.props.search) {
      // this.props.getUsers(this.props.search)
      if (this.searchTimer)
        clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(this.performSearch, SEARCH_DELAY_MS)
      return
    }
    
    if (postPeople.users.search == this.props.search && previousProps.postPeople.users.timeStamp != postPeople.users.timeStamp && !postPeople.users.fetching && !postPeople.users.error) {
      // new users, take some, cache the rest, load up some user posts!
      this._dataProvider = this._dataProvider.cloneWithRows([])
      this.userCache = []
      const users = postPeople.users.data
      for (let i = 0; i < users.length; i++) {
        const userId   = typeof(users[i]) == 'string' ? users[i] : users[i].UserId
        const userName = typeof(users[i]) == 'string' ? `User ${userId}` : users[i].Username
        const newUser = {
          placeHolder: true,
          tileColor: '#ffffff',
          UserId: userId,
          Username: '...',
          FirstName: '',
          LastName: '',
          UserIsFollowing: null,
          Posts: [],
        }
        this.userCache.push(newUser)
      }
      this.addRowsFromCache()
    }
    
    if (previousProps.postPeople.usersAndPosts.timeStamp != postPeople.usersAndPosts.timeStamp && !postPeople.usersAndPosts.fetching && !postPeople.usersAndPosts.error) {
      // extended data
      const changedRows = this._dataProvider._data.slice(0)
      let userIdLookup = {}
      for (let i = 0; i < changedRows.length; i++)
        userIdLookup[changedRows[i].UserId] = i
      const extendedUserData = postPeople.usersAndPosts.data
      for (let i = 0; i < extendedUserData.length; i++) {
        const userId = extendedUserData[i].UserId
        const index = typeof userIdLookup[userId] != 'undefined' ? userIdLookup[extendedUserData[i].UserId] : false
        if (index !== false)
          changedRows[index] = extendedUserData[i]
        else
          console.tron.display({name: 'ExploraPeople', preview: `componentDidUpdate user not found`, value: {userId: userId, index: index, i: i, userIdLookup: userIdLookup, extendedUserData: extendedUserData}})
      }
      console.tron.display({name: 'ExploraPeople', preview: `componentDidUpdate extended data`, value: {userIdLookup: userIdLookup, changedRows: changedRows}})
      this._dataProvider = this._dataProvider.cloneWithRows(changedRows)
      this.setState({render: Date.now()})
    }
  }
  
  addRowsFromCache() {
    console.tron.display({name: 'ExploraPeople', preview: `addRowsFromCache start`, value: {userCache: this.userCache}})
    if (this.userCache.length) {
      const existingRows = this._dataProvider._data
      const newRows      = this.userCache.splice(0, 20)
      const mergedRows   = existingRows.concat(newRows)
      this._dataProvider = this._dataProvider.cloneWithRows(mergedRows)
      let userIds = []
      for (let i = 0; i < newRows.length; i++)
        userIds.push(newRows[i].UserId)
      console.tron.display({name: 'ExploraPeople', preview: `addRowsFromCache newRows`, value: {userCache: this.userCache, newRows: newRows, userIds: userIds}})
      this.props.getUsersAndPosts(userIds)
      this.setState({render: Date.now(), refreshing: false})
    }
  }
  
  followUnfollow(userId) {
    const loggedInUserId = this.props.auth.user.UserId
    let isFollowing = null // not a boolean
    let newRows = this._dataProvider._data.slice(0)
    for (let i = 0; i < newRows.length; i++)
      if (newRows[i].UserId == userId) {
        isFollowing = !newRows[i].UserIsFollowing
        newRows[i] = Object.assign({}, newRows[i], {UserIsFollowing: isFollowing})
      }
    if (isFollowing != null) {
      console.tron.log(`ExploraPeople followUnfollow, userId ${userId} was found, follow state now: ${isFollowing}`)
      this._dataProvider = this._dataProvider.cloneWithRows(newRows)
      if (isFollowing)
        this.props.followUser(loggedInUserId, userId)
      else
        this.props.unfollowUser(loggedInUserId, userId)
      this.setState({render: Date.now()})
    }
    else
      console.tron.log(`ExploraPeople followUnfollow, userId ${userId} was not found`)
  }
  
  _loadMoreData() {
    console.tron.display({name: 'ExploraPeople', preview: `_loadMoreData, search: ${this.props.search}`, value: {search: this.props.search}})
    this.addRowsFromCache()
/*
    // call the api to get more data (or just from local cache)
//                       {this.state.activeTab === 1 && <ExploraPeople search={this.state.searchText} postPeople={this.props.postPeople} getUsers={this.props.getUsers} getUsersAndPosts={this.props.getUsersAndPosts} data={this.state.peopleData} more={this.getMorePeople} empty={this.empty} onRefresh={( ) => this.onRefresh(1)} refreshing={this.state.refreshing} ref={ref=>this.exploraPeople=ref} onAvatarPress={this.onAvatarPress} onPressPost={this.onPressPeople} onPressRightIcon={this.onPressFollow} resetIdleTimeout={this.resetIdleTimeout}/>}
    const postPeople = this.props.postPeople
    if (!postPeople.users.fetching && !postPeople.usersAndPosts.fetching) {
      this.props.getUsers(this.props.search)
    }
*/
  } // _loadMoreData
  
  _onRefresh() {
    console.tron.log(`ExploraPeople _onRefresh`)
    this.setState({refreshing: true})
    this.props.getUsers(this.props.search)
  }

  _renderRow(type, data, index) {
    // console.tron.display({name: 'ExploraPeople', preview: "_renderRow", value: {type: type, data: data, index: index}})
    const height = type == 'NO-POSTS' ? noPostsHeight : withPostsHeight
    // TODO: disable follow button until we have the follow state
    if (false && data.placeHolder)
      return (
        <View style={{ backgroundColor : data.tileColor, width : width, minHeight : height, overflow : 'hidden' }}>
        </View>
      )
    else
      return (
        <View style={{ backgroundColor : data.tileColor, width : width, minHeight : height, overflow : 'hidden' }}>
          <FollowComponent
            onAvatarPress={this.props.onAvatarPress}
            onPressRightIcon={() => this.followUnfollow(data.UserId)}
            key={index}
            subTitle={data.FirstName + " " + data.LastName}
            title={data.Username}
            userId={data.UserId}
            data={data}
            userIsFollowing={data.UserIsFollowing}
            followBtnEnabled={typeof data.placeHolder == 'undefined'}
          />
          {!!data.Posts && data.Posts.length > 0 && <View style={{ flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
            {data.Posts.map((postInfo, index) => <ImageComponent isZoomed useThumb={true} onPress={() => this.props.onPressPost(postInfo,postInfo)} key={index} index={index} data={postInfo} />)}
          </View>}
        </View>    
      )
  } // _renderRow

  render() {
/*
extendedState={extendedStateMosaic}
initialRenderIndex={initialMosaicRenderIndex}
onScroll={this.state.isProfile == false ? this._onScrollThumbs : this.state.isMyProfile ? eventChild : eventChildOtherProfile}
refreshControl={
  <RefreshControl refreshing={this.state.refreshing} onRefresh={this._onRefresh}>
    {refreshChild}
  </RefreshControl>
}
*/

    const postPeople = this.props.postPeople
    if (this.props.search && postPeople.users.search == this.props.search && !postPeople.users.fetching && !postPeople.users.error && postPeople.users.data.length == 0)
      return (
        <View style={{ width : width, flex : 1, flexDirection : 'column', justifyContent : 'flex-start', alignItems : 'center' }}>
          <Text style={{ color : '#ccc', fontWeight : 'bold', fontFamily : Fonts.style.font.regular, fontSize : 30, lineHeight : 50, height : 50 }}>Sorry No Results</Text>
          <Image source={Images.sorryNoResults} resizeMode='contain' style={{ marginLeft: -30, marginTop: 0, width : width * (1/3), height : 200 }}/>
        </View>
      )

    const style = {flex: 1}
    return (
      <RecyclerListView
        dataProvider={this._dataProvider}
        layoutProvider={this._layoutProvider}
        onEndReached={this._loadMoreData}
        onEndReachedThreshold={500}
        ref={scrollView => this.scrollView = scrollView}
        renderAheadOffset={250}
        rowRenderer={this._renderRow}
        showsVerticalScrollIndicator={false}
        style={style}
        refreshControl={
          <RefreshControl refreshing={this.state.refreshing} onRefresh={this._onRefresh}>
          </RefreshControl>
        }
      />
    )
  } // render
}


// FlatList version
// export default class ExploraPeople extends Component {
class ExploraPeople_OLD extends Component {
  constructor(props) {
    super(props)
  }
  componentDidUpdate(previousProps, previousState) {
    if (this.props.data !== previousProps.data && this.scrollView)
      this.scrollView.scrollToOffset({ offset : 0, animated : false })
  }
  onViewableItemsChanged = ({ changed, viewableItems }) => {
    var viewable = 0, hit = 0
    if(! viewableItems.length) return false
    for(var i = 0, data = this.props.data[i]; i < this.props.data.length; data = this.props.data[++i]) {
      if(i == viewableItems[0].index) {
        data.viewable = true
        hit = 1
        ++viewable
      }
      else if(hit && viewableItems.length > hit) ++hit && ++viewable && (data.viewable = true)
      else if(data.viewable) ++viewable
    }
    let offscreenElements = 10
    var min = viewableItems[0].index, max = viewableItems[viewableItems.length -1].index
    if(min - offscreenElements < 0) min = 0; else min = min - offscreenElements
    if(max + offscreenElements > this.props.data.length -1) max = this.props.data.length -1; else max = max + offscreenElements
    for(var i = min; i < min+offscreenElements; ++i) if(this.props.data[i]) this.props.data[i].viewable = true
    for(var i = max; i > max-offscreenElements; --i) if(this.props.data[i]) this.props.data[i].viewable = true
    if(hit > 0 || viewable === this.props.data.length) this.props.resetIdleTimeout(hit)

    // when 100% of items are viewable, signal idle state immediately
    // set a timeout of DownloadImageAverageTime, then signal idle state
    // when idle state is procced, we'll 'finally' download other tabs in the background
    this.setState({ render : true })
    // for(var i = 0; i < changed.length; ++ i) if(! changed[i].isViewable && this.props.data[changed[i].index]) this.props.data[changed[i].index].viewable = false
  }
  render( ) {
    console.tron.display({name: 'ExploraPeople', preview: "render", value: {data: this.props.data}})
    return (
          <FlatList windowSize={4 /*n screens*/} ref={ref=>this.scrollView=ref} contentContainerStyle={{ paddingBottom : 333, backgroundColor : 'white' }} data={this.props.data}
              onViewableItemsChanged={this.onViewableItemsChanged} ListEmptyComponent={this.props.empty}
              viewabilityConfig={viewabilityConfig} keyExtractor={(item, index) => `${index}-${item.UserId}`}
              onEndReached={this.props.more} onEndReachedThreshold={0.75}
              onRefresh={this.props.onRefresh} refreshing={this.props.refreshing}
              renderItem={({ item, index }) =>
                  item.viewable
                      ? <View style={{ backgroundColor : item.tileColor, width : width, minHeight : minHeight, overflow : 'hidden' }}
                              onLayout={({ nativeEvent : { layout }}) => item.height = layout.height }>
                          <FollowComponent
                            onAvatarPress={this.props.onAvatarPress}
                            onPressRightIcon={() => this.props.onPressRightIcon(item, index)}
                            key={index}
                            subTitle={item.FirstName + " " + item.LastName}
                            title={item.Username}
                            userId={item.UserId}
                            data={item}
                            userIsFollowing={item.UserIsFollowing}
                          />
                          {item.Posts.length && <View style={{ flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
                            {item.Posts.map((data, index) => <ImageComponent useThumb={true} isZoomed onPress={() => this.props.onPressPost(data,item)} key={index} index={index} data={data} />)}
                          </View>}
                        </View>
                      : <View style={{ width : width, height : item.height || minHeight }}/>
              }/>
      )
  }
}
